export enum InvoiceGovernmentType {
  UNION = 'UNION',
  ESTATE = 'ESTATE',
  FEDERAL_DISTRICT = 'FEDERAL_DISTRICT',
  MUNICIPALITY = 'MUNICIPALITY',
}

export const InvoiceGovernmentTypeLabel: Record<InvoiceGovernmentType, string> =
  {
    UNION: '1 - União',
    ESTATE: '2 - Estado',
    FEDERAL_DISTRICT: '3 - Distrito Federal',
    MUNICIPALITY: '4 - Município',
  };

export enum InvoiceGovernmentOperation {
  SUPPLY = 'SUPPLY',
  RECEIPT = 'RECEIPT',
}

export const InvoiceGovernmentOperationLabel: Record<
  InvoiceGovernmentOperation,
  string
> = {
  SUPPLY: '1 - Fornecimento',
  RECEIPT:
    '2 - Recebimento do pagamento, conforme fato gerador do IBS/CBS definido no Art. 10 § 2º',
};
